module.exports = __webpack_public_path__ + "img/express.ceed11fa.png";